export default "__VITE_ASSET__BaC1AO5H__"